import { DataWidgetLayout } from "@me8eon/data_widget";
import { EonUiLink } from "@eon-ui/eon-ui-components-react";
import { useSelectedDataViewName } from "@me8eon/data_view_filter";
import React, { useCallback } from "react";
import { useTranslation } from "@me8eon/translation";

export const LayoutWithTitleAndMore = (title: string): DataWidgetLayout => {
    // Give the returned component an explicit name for DevTools & stack traces
    const WithTitleAndMore: DataWidgetLayout = ({ children, rootId }) => {
        const t = useTranslation();
        // ignore the current view, only need the setter
        const [, setDataView] = useSelectedDataViewName();

        // stable callback identity
        const onMoreClick = useCallback(() => setDataView("m365"), [setDataView]);

        return (
            <div data-testid={`${rootId}-layout`}>
                {/* consider adding data-testid={`${rootId}-heading`} */}
                <div className="unified-box-heading">
                    {t(title)}
                    <EonUiLink
                        data-testid={`${rootId}-about-me8eon`}
                        size="small"
                        slot="links"
                        target="_blank"
                        text={t("searchPage.viewMoreApps")}
                        onClick={onMoreClick}
                        aria-label={t("searchPage.viewMoreApps")}
                    />
                </div>
                <div className="unified-box-content">
                    {children}
                </div>
            </div>
        );
    };
    return WithTitleAndMore;
};
